

























































import { Component, Mixins } from "vue-property-decorator";
import { FormatReference, WriteMethodTypeValue } from "../../../domain/format";
import { SelectorDialogMixin } from "../../system/dialogs/mixins";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../system/selectors";
import MultiOrderableFormatListSelector from "../selectors/MultiOrderableFormatListSelector.vue";
import { IFormatListSelectorDialogCondition, instanceOfIFormatListSelectorDialogCondition } from ".";
import { instanceOfIMultiDepartmentListSelectorDialogCondition } from "./IMultiFormatListSelectorDialogCondition";

@Component({
  components: {
    MultiOrderableFormatListSelector,
  },
})
export default class MultiFormatListSelectorDialog extends Mixins(SelectorDialogMixin) implements IMultiSelectableAsynchronously<FormatReference>, IMultiSelectableConditionallyAsynchronously<FormatReference, IFormatListSelectorDialogCondition> {
  data(): any {
    return {
      name: this.formatNameWording,
      containsExpired: false,
      containsDeleted: false,
      shouldIgnoreChained: false,
      defaultWriteMethodTypes: null as WriteMethodTypeValue[],
      defaultMultiSelect: false,
      shouldIncludeReferenceableGroupFormats: false,
    };
  }
  name: string;
  containsExpired: boolean;
  containsDeleted: boolean;
  shouldIgnoreChained: boolean;
  defaultWriteMethodTypes: WriteMethodTypeValue[];
  defaultMultiSelect: boolean;
  shouldIncludeReferenceableGroupFormats: boolean;

  visibleTabs: any[] = MultiOrderableFormatListSelector.formatTabs;

  get selectionMaxCount(): number {
    return this.$configuration.behavior.format.multiSelector.max;
  }

  get additionMaxCount(): number {
    return this.$configuration.behavior.format.multiSelector.addition.max;
  }

  get isSelectable(): boolean {
    return this.hasSelected && !this.isOverSelectionMaxCount;
  }

  get isOverSelectionMaxCount(): boolean {
    return this.selected && this.selected.length > this.selectionMaxCount;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  async selectOptions(defaultOptions?: FormatReference[]): Promise<FormatReference[]> {
    return this.show<FormatReference[]>(defaultOptions);
  }

  async selectOptionsConditionally(condition: IFormatListSelectorDialogCondition, defaultOption?: FormatReference[]): Promise<FormatReference[]> {
    // TODO: 他のパラメータの値もクリアしてから適用する必要あるのでは？
    this.shouldIncludeReferenceableGroupFormats = false;
    if (instanceOfIFormatListSelectorDialogCondition(condition)) {
      this.name = condition.name ? condition.name : this.formatNameWording;
      this.containsExpired = condition.containsExpired;
      this.containsDeleted = condition.containsDeleted;
      this.shouldIgnoreChained = condition.shouldIgnoreChained;
      this.defaultWriteMethodTypes = condition.defaultWriteMethodTypes ? condition.defaultWriteMethodTypes : [];
      this.shouldIncludeReferenceableGroupFormats = !!condition.shouldIncludeReferenceableGroupFormats;
    }
    if (instanceOfIMultiDepartmentListSelectorDialogCondition(condition)) {
      this.defaultMultiSelect = condition.isMultiSelectable;
    }
    return this.show<FormatReference[]>(defaultOption);
  }

  formatsSelected(selectedFormats: FormatReference[]): void {
    this.select(selectedFormats);
  }
}
